import { useNotification } from "@expert/common-ui";
import { getLogger } from "@expert/logging";
import { useEffect } from "react";

import { sdkEventBus } from "@/sdk";
import {
    CUSTOMER_DROPPED_MESSAGE,
    useIsCustomerDroppedNoticeEnabled,
} from "@/session-summary/components/customerDroppedNotice";

const logger = getLogger({ module: "useCustomerDroppedNotice" });

/**
 * Tells the expert the customer's end disconnected as it happens, so silence on the line isn't
 * mistaken for an audio fault. The session summary repeats it as a banner once wrap-up opens.
 * Every drop logs whether this expert sees the notice, so the flag's two arms can be compared.
 */
export const useCustomerDroppedNotice = () => {
    const notification = useNotification();
    const isNoticeEnabled = useIsCustomerDroppedNoticeEnabled();

    useEffect(() => {
        return sdkEventBus.on("call_customer_dropped", (task) => {
            logger.info({ taskId: task.id, isNoticeEnabled }, "Customer dropped notice evaluated");
            if (isNoticeEnabled) notification.info(CUSTOMER_DROPPED_MESSAGE);
        });
    }, [isNoticeEnabled, notification]);
};
